import { Button, Card } from "@fanduel/og-fe-library";
import cx from "classnames";
import Link from "next/link";
import { useRouter } from "next/router";
import styles from "./raceControls.module.scss";

const ViewFilter = () => {
  const { query } = useRouter();
  const { track, race: raceNumber, tab } = query;
  const currentTab = Number.parseInt(tab?.toString() ?? "1", 10);
  const raceQuery = raceNumber ? `?race=${raceNumber}&` : "?";
  const url = `/horse-racing/picks/${track?.[0]}/${track?.[1]}${raceQuery}`;
  return (
    <Card
      variant="elevation"
      elevation="mid"
      className={styles.viewFilterContainer}
    >
      <p>VIEW</p>
      <div className={styles.buttonGroup}>
        <Link href={`${url}tab=1`}>
          <Button
            buttonStyle={currentTab === 1 ? "Naked" : ""}
            className={cx(currentTab === 1 && styles.active)}
            buttonText="Full Race Card"
          />
        </Link>
        <Link href={`${url}tab=2`}>
          <Button
            buttonStyle={currentTab === 2 ? "Naked" : ""}
            className={cx(currentTab === 2 && styles.active)}
            buttonText="Consensus Picks"
          />
        </Link>
      </div>
    </Card>
  );
};

export default ViewFilter;
